import {Component, Input, OnInit} from '@angular/core';
import {Detalhamento} from '../../detalhamento';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {RdsModalComponent} from '../../../../shared/rds/rds-modal.component';

@Component({
    selector: 'store-disponibilizacao-licenciamento',
    templateUrl: './disponibilizacao-licenciamento.component.html',
    styleUrls: ['./disponibilizacao-licenciamento.component.scss']
})
export class DisponibilizacaoLicenciamentoComponent implements OnInit {

    @Input()
    public detalhamento: Detalhamento;
    public isExtensao: boolean;

    constructor(private modalService: NgbModal) {
    }

    ngOnInit() {
        this.isExtensao = this.detalhamento.plataforma.chave === 'EXTENSAO';
    }

    ativarLicenca(urlLicenca): void {
        window.open(urlLicenca, '_blank');
    }

    solicitar(): void {
        const modalRef = this.modalService.open(RdsModalComponent);
        modalRef.componentInstance.isExtensao = this.isExtensao
    }

}
